export function getDecryptUrlFactory(res): any {
    return res
}
